<div class="leads-container">
  <div class="page-header">
    <h2>Direct Phone Leads</h2>
    <span class="premium-badge">
      <span class="material-symbols-outlined">diamond</span>
      Premium Feature
    </span>
  </div>

  <div *ngIf="loading" class="loading-state">
    <div class="spinner-border" role="status"></div>
    <p>Searching for premium leads in your area...</p>
  </div>

  <div *ngIf="!loading && leads.length === 0" class="empty-state">
    <span class="material-symbols-outlined icon">assignment_late</span>
    <h4>No Leads Found</h4>
    <p>When couples in your city request a quote for your services, they will appear here instantly.</p>
    <button class="btn-upgrade-cta mt-4" routerLink="/merchant/subscription">
      <span class="material-symbols-outlined">rocket_launch</span>
      Upgrade to get leads from your area
    </button>
  </div>

  <div *ngIf="!loading && leads.length > 0" class="leads-grid">
    <div class="lead-card" *ngFor="let lead of leads">
      <div class="card-header">
        <div class="couple-info">
          <h4>{{ lead.coupleName }}</h4>
          <div class="event-date">
            <span class="material-symbols-outlined">event</span>
            {{ lead.eventDate | date:'mediumDate' }}
          </div>
        </div>
      </div>
      
      <div class="card-body">
        <div class="info-row">
          <span class="material-symbols-outlined">location_on</span>
          {{ lead.city }}
        </div>
        <div class="info-row">
          <span class="material-symbols-outlined">category</span>
          {{ lead.categoriesNeeded.join(', ') }}
        </div>
        
        <div class="budget-tag" *ngIf="lead.budget">
          <span class="label">Estimated Budget</span>
          <span class="amount">{{ lead.budget }}</span>
        </div>
      </div>

      <div class="card-actions">
        <button class="btn-contact" [disabled]="lead.phone.includes('*')">
          <span class="material-symbols-outlined">call</span>
          {{ lead.phone }}
        </button>
        <button class="btn-upgrade-link mt-2" routerLink="/merchant/subscription" *ngIf="lead.phone.includes('*')">
          <span class="material-symbols-outlined">workspace_premium</span>
          Unlock Premium to view contact details
        </button>
      </div>
    </div>
  </div>
</div>
